<eo-form
  #eoFormContactForm
  class="extended-form-container"
  submitButtonStyleClass="w-full p-fluid"
  submitButtonDivStyleClass="px-3 pb-3"
  [config]="examplePageFormConfig"
  [submitButtonVisible]="false"
>
</eo-form>
